import { Routes } from '@angular/router';
import { URLS } from '@constants/urls';
import { DashboardsComponent } from '@pages/dashboards/dashboards.component';
import { PropertyServicesComponent } from '@pages/property-services/property-services.component';
import { BenchmarksComponent } from '@pages/property-services/tabs/benchmarks/benchmarks.component';
import { CostsTariffsComponent } from '@pages/property-services/tabs/costsTariffs/costsTariffs.component';
import { AssetManagementComponent } from '@pages/asset-management/asset-management.component';
import { GroupsComponent } from '@pages/asset-management/tabs/groups/groups.component';
import { ControlsComponent } from '@pages/controls/controls.component';
import { ManualControlComponent } from '@pages/controls/tabs/manualControl/manualControl.component';
import { AutomationsComponent } from '@pages/controls/tabs/automations/automations.component';
import { AlarmsComponent } from '@pages/alarms/alarms.component';
import { ReportsComponent } from '@pages/reports/reports.component';
import { SettingsComponent } from '@pages/settings/settings.component';
import { UsersComponent } from '@pages/settings/tabs/users/users.component';
import { AccountComponent } from '@pages/settings/tabs/account/account.component';
import { NotificationsComponent } from '@pages/settings/tabs/notifications/notifications.component';
import { GeneralComponent } from '@pages/settings/tabs/general/general.component';
import { TestComponent } from '@pages/test/test.component'; // MEMO: temporaneo
import { authGuard } from 'app/auth/auth.guard';
import { SignUpComponent } from '@pages/signup/signup.component';
import { LoginComponent } from '@pages/login/login.component';
import { HomeComponent } from '@pages/home/home.component';
import { PageNotFoundComponent } from '@pages/page-not-found/page-not-found.component';
import { DefinitionsComponent } from '@pages/controls/tabs/automations/tabs/definitions/definitions.component';
import { LogsComponent } from '@pages/controls/tabs/automations/tabs/logs/logs.component ';
import { AlarmsLogsComponent } from '@pages/alarms/tabs/alarms-logs/alarms-logs.component';
import { AlarmsListComponent } from '@pages/alarms/tabs/alarms-list/alarms-list.component';
import { WizardFirstAccessComponent } from '@pages/login/wizard-first-access/wizard-first-access.component';
import { PageUnauthorizedComponent } from '@pages/page-unauthorized/page-unauthorized.component';
import { ReportTemplatePrintPageComponent } from '@pages/reports/report-template-print-page/report-template-print-page.component';
import { UserLogsComponent } from '@pages/settings/tabs/user-logs/user-logs.component';

export const routes: Routes = [
  {
    path: URLS.LOGIN,
    canActivate: [authGuard],
    component: LoginComponent,
  },
  {
    path: URLS.SIGNUP,
    canActivate: [authGuard],
    component: SignUpComponent,
  },
  {
    path: URLS.FIRST_ACCESS_WIZARD,
    canActivate: [authGuard],
    component: WizardFirstAccessComponent,
  },
  { path: URLS.UNAUTHORIZED, component: PageUnauthorizedComponent },
  {
    path: URLS.TEST, // MEMO: temporaneo,
    component: TestComponent,
  },
  {
    path: URLS.REPORT_TEMPLATE_PRINT_PAGE,
    component: ReportTemplatePrintPageComponent,
    canActivateChild: [authGuard],
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: URLS.DASHBOARDS,
        pathMatch: 'full',
      },
      {
        path: URLS.DASHBOARDS,
        component: DashboardsComponent,
        canActivateChild: [authGuard],
      },
      {
        path: URLS.PROPERTIES,
        children: [
          {
            loadComponent: () =>
              import('./pages/properties/properties.component').then(
                (p) => p.PropertiesComponent
              ),
            path: '',
            pathMatch: 'full',
            canActivateChild: [authGuard],
          },
          {
            loadComponent: () =>
              import(
                './pages/properties/property-details/property-details.component'
              ).then((p) => p.PropertyDetailsComponent),
            path: ':id',
            canActivateChild: [authGuard],
            //TODO: da sistemare
            /* resolve: {
              property: propertyResolver,
            }, */
            children: [
              {
                path: '',
                redirectTo: 'devices',
                pathMatch: 'full',
              },
              {
                path: 'events',
                pathMatch: 'full',
                canActivateChild: [authGuard],
                loadComponent: () =>
                  import(
                    './pages/properties/property-details/property-events/property-events.component'
                  ).then((p) => p.PropertyEventsComponent),
              },
              {
                path: 'devices',
                pathMatch: 'full',
                canActivateChild: [authGuard],
                loadComponent: () =>
                  import(
                    './pages/properties/property-details/property-devices/property-devices.component'
                  ).then((p) => p.PropertyDevicesComponent),
              },
            ],
          },
        ],
        canActivateChild: [authGuard],
      },
      {
        path: URLS.ASSETMANAGEMENT,
        component: AssetManagementComponent,
        children: [
          {
            path: '',
            redirectTo: URLS.DEVICES,
            pathMatch: 'full',
          },
          {
            path: URLS.DEVICES,
            children: [
              {
                path: '',
                pathMatch: 'full',
                loadComponent: () =>
                  import(
                    './pages/asset-management/tabs/devices/devices.component'
                  ).then((p) => p.DevicesComponent),
              },
            ],
            canActivateChild: [authGuard],
          },
          {
            path: URLS.GROUPS,
            component: GroupsComponent,
            canActivateChild: [authGuard],
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: URLS.DEVICES,
          },
        ],
      },
      {
        path: URLS.ASSETMANAGEMENT,
        children: [
          {
            path: URLS.DEVICES,
            children: [
              {
                path: ':id',
                loadComponent: () =>
                  import(
                    './pages/asset-management/asset-details/asset-details.component'
                  ).then((p) => p.DeviceDetailsComponent),
              },
            ],
          },
        ],
        canActivateChild: [authGuard],
      },
      {
        path: URLS.CONTROLS,
        component: ControlsComponent,
        children: [
          {
            path: '',
            redirectTo: URLS.MANUALCONTROL,
            pathMatch: 'full',
          },
          {
            path: URLS.MANUALCONTROL,
            component: ManualControlComponent,
            canActivateChild: [authGuard],
          },
          {
            path: URLS.AUTOMATIONS,
            component: AutomationsComponent,
            children: [
              {
                path: '',
                redirectTo: URLS.CONFIGURED,
                pathMatch: 'full',
              },
              {
                path: URLS.CONFIGURED,
                component: DefinitionsComponent,
                canActivateChild: [authGuard],
              },
              {
                path: URLS.LOGS,
                component: LogsComponent,
                canActivateChild: [authGuard],
              },
            ],
            canActivateChild: [authGuard],
          },
        ],
        canActivateChild: [authGuard],
      },
      {
        path: URLS.PROPERTYSERVICES,
        component: PropertyServicesComponent,
        children: [
          {
            path: '',
            redirectTo: URLS.BENCHMARKS,
            pathMatch: 'full',
          },
          {
            path: URLS.BENCHMARKS,
            component: BenchmarksComponent,
            canActivateChild: [authGuard],
          },
          {
            path: URLS.COSTSTARIFFS,
            component: CostsTariffsComponent,
            canActivateChild: [authGuard],
          },
        ],
        canActivateChild: [authGuard],
      },
      {
        path: URLS.ALARMS,
        component: AlarmsComponent,
        canActivateChild: [authGuard],
        children: [
          {
            path: '',
            redirectTo: URLS.ALARMSLIST,
            pathMatch: 'full',
          },
          {
            path: 'list',
            component: AlarmsListComponent,
            canActivateChild: [authGuard],
          },
          {
            path: 'logs',
            component: AlarmsLogsComponent,
            canActivateChild: [authGuard],
          },
        ],
      },
      {
        path: URLS.REPORTS,
        component: ReportsComponent,
        canActivateChild: [authGuard],
      },
      {
        path: URLS.SETTINGS,
        component: SettingsComponent,
        children: [
          {
            path: '',
            redirectTo: URLS.ACCOUNT,
            pathMatch: 'full',
          },
          {
            path: URLS.ACCOUNT,
            component: AccountComponent,
            canActivateChild: [authGuard],
          },
          {
            path: URLS.NOTIFICATIONS,
            component: NotificationsComponent,
            canActivateChild: [authGuard],
          },
          {
            path: URLS.GENERAL,
            component: GeneralComponent,
            canActivateChild: [authGuard],
          },
          {
            path: URLS.USERS,
            component: UsersComponent,
            canActivateChild: [authGuard],
          },
          {
            path: URLS.USERlOGS,
            component: UserLogsComponent,
            canActivateChild: [authGuard],
          },
        ],
        canActivateChild: [authGuard],
      },
      {
        path: '**',
        component: PageNotFoundComponent,
      },
    ],
  },
];
